module.exports = __webpack_public_path__ + "img/edge_activites_via_ferrata.bea55962.svg";